import {RestService} from './_rest.service'
import {REST_API_END_POINTS} from './constants'

import {RepairPayload, Ticket} from "../types";
import {AxiosResponse} from "axios";

export class TicketService extends RestService<Ticket> {
    constructor(url?: string) {
        url ? super(url) : super(REST_API_END_POINTS.TICKETS)
    }

    details_by_reference_number(reference_number: string) {
        return this.instance.get(
            `${REST_API_END_POINTS.TICKETS
            }/details_by_reference_number/${reference_number}/`
        )
    }

    change_status(payload) {
        return this.instance.post(`${this.url}change_status`, payload)
    }

    send_delivery_otp(payload) {
        return this.instance.post(`${this.url}send_delivery_otp`, payload)
    }

    verify_delivery_otp(payload) {
        return this.instance.post(`${this.url}verify_delivery_otp`, payload)
    }

    send_ticket_details_by_email() {
        return this.instance.post(`${this.url}send_ticket_details_by_email`)
    }

    send_ticket_details_by_email_with_pdf() {
        return this.instance.post(
            `${this.url}send_ticket_details_by_email_with_pdf`
        )
    }

    send_ticket_details_by_sms() {
        return this.instance.post(`${this.url}send_ticket_details_by_sms`)
    }

    send_disclaimer_by_email(type: string) {
        return this.instance.post(`${this.url}disclaimer_pdf/${type}`)
    }

    send_ticket_status_by_email() {
        return this.instance.post(`${this.url}send_ticket_status_by_email`)
    }

    send_ticket_status_by_sms() {
        return this.instance.post(`${this.url}send_ticket_status_by_sms`)
    }

    send_estimation_pdf() {
        return this.instance.post(`${this.url}estimation_pdf`)
    }


    get_gsx_data(): Promise<AxiosResponse<RepairPayload>> {
        return this.instance.get<RepairPayload>(`${this.url}get_gsx_data/`)
    }

    get_pin_code_info(pin_code: string) {
        return this.instance.get(`${this.url}pin_code_info/${pin_code}/`)
    }
}
